import {ConnectBasicEntity} from '../../framework/message/ConnectBasicEntity';

export class ProcessStepPartitioner extends ConnectBasicEntity {
fromQuery: boolean | null;
key: string;
multithread: boolean | null;
processCode: string;
processMappingStepcode: string;
queryParams: string;
size: number | null;
sort: boolean | null;
visionCode: string;
}

